import {
    SpecialMarket,
    SpecialMarketCriteria,
    SpecialMarketSettings
} from "api/models/specialMarkets";
import api from "api/utils";

const baseUrl = "api/specialMarket";

const get = async(criteria?: SpecialMarketCriteria) => {
    return await api.query<SpecialMarketCriteria, SpecialMarket[]>({
        baseUrl: `${baseUrl}`,
        queryParams: criteria
    });
};

const getSettings = async ()=> {
    return await api.query<undefined, SpecialMarketSettings>({
        baseUrl: `${baseUrl}/settings`
    });
};

const save = async(companyBrandValue?: SpecialMarket) =>{
    return await api.command<SpecialMarket, undefined>({
        baseUrl: `${baseUrl}`,
        body: companyBrandValue,
        method: "POST"
    });
};

const specialMarketService = {
    get,
    save,
    getSettings
};

export default specialMarketService;